import { GameObjects } from "phaser";

import { GButton } from "../gameobjects/GButton";


import { stringToNumberArray } from '../utils';

export class WinningNumbers extends GameObjects.Container {
    constructor(scene, x, y, data) {
        super(scene, x, y);

        this.numbersArray = stringToNumberArray(data.numbersArray.numbers);

        this.WinningNumbers = stringToNumberArray(data.winningNumbers)

        this.ticketNumber = data.ticketNumber+1;
        
        // Add this container to the scene
        scene.add.existing(this);


        const ticketNumberText = this.scene.add.text(-30, 0, `TICKET ${this.ticketNumber}`, {
            fontFamily: 'Oswald', 
            fontSize: '38px',
            color: '#fff',
        }).setOrigin(0, 0); // Set origin to top-left;
        ticketNumberText.setOrigin(0).setPadding({ left: 0,  top: 0 });
        ticketNumberText.setFontStyle('700')

        // Add the text object to this container
        this.add(ticketNumberText);



        // Call the method to create and display the text objects
        this.createGrid();



        // const ticketCostText = this.scene.add.text(500, 12, `COST:`, {
        //     fontFamily: 'Oswald', 
        //     fontSize: '24px',
        //     color: '#BEBEBE',
        // }).setOrigin(0, 0); // Set origin to top-left;
        // ticketCostText.setFontStyle('700')

        // this.add(ticketCostText);

        // const ticketPriceText = this.scene.add.text(500 + ticketCostText.width +5, 12, `$${data.numbersArray.price}`, {
        //     fontFamily: 'Oswald', 
        //     fontSize: '24px',
        //     color: '#FFF',
        // }).setOrigin(0, 0); // Set origin to top-left;
        // ticketPriceText.setFontStyle('700')

        // this.add(ticketPriceText);


        const bounds = this.getBounds()

        //console.log("bounds", bounds)


        const ticketPriceText = this.scene.add.text(bounds.width -50, 12, `$${data.numbersArray.price}`, {
            fontFamily: 'Oswald', 
            fontSize: '24px',
            color: '#FFF',
        }).setOrigin(1, 0); // Set origin to top-left;
        ticketPriceText.setFontStyle('700')

        this.add(ticketPriceText);

        const ticketCostText = this.scene.add.text(ticketPriceText.x - ticketPriceText.width - 16, 12, `COST:`, {
            fontFamily: 'Oswald', 
            fontSize: '24px',
            color: '#BEBEBE',
        }).setOrigin(1, 0); // Set origin to top-left;
        ticketCostText.setFontStyle('700')

        this.add(ticketCostText);


        if(data.numbersArray.prize_amount > 0){

            const ticketWinningAmountText = this.scene.add.text(ticketCostText.x - ticketPriceText.width - 64 , 12, `$${data.numbersArray.prize_amount}`, {
                fontFamily: 'Oswald', 
                fontSize: '24px',
                color: '#FFF',
            }).setOrigin(1, 0); // Set origin to top-left;
            ticketWinningAmountText.setFontStyle('700')
    
            this.add(ticketWinningAmountText);


            const ticketWinningsText = this.scene.add.text(ticketWinningAmountText.x - ticketWinningAmountText.width - 16, 12, `WINNINGS:`, {
                fontFamily: 'Oswald', 
                fontSize: '24px',
                color: '#BEBEBE',
            }).setOrigin(1, 0); // Set origin to top-left;
            ticketWinningsText.setFontStyle('700')
    
            this.add(ticketWinningsText);
    
           

        }

       
    }

    // Method to create and display the grid of numbers as text objects
    createGrid() {
        const columns = 6;       // Number of columns
        const textSpacingX = (40 + 15)*2 ; // Horizontal space between text objects
        const textSpacingY = (40 + 16)*2; // Vertical space between text objects

        for (let i = 0; i < this.numbersArray.length; i++) {
            const number = this.numbersArray[i];

            // Calculate the x and y position for each text object
            const x = (i % columns) * textSpacingX;
            const y = Math.floor(i / columns) * textSpacingY + 116;

            // Create the text object for the current number
            let numberCircle
            if(!this.WinningNumbers.includes(number)){
                numberCircle = this.scene.add.sprite(x, y, 'pack' ,'Lotto Number - Unselected - Default.png');
            }else {
                numberCircle = this.scene.add.sprite(x, y, 'pack' ,'Lotto Number - Winner - Default.png');
                const numberTick = this.scene.add.sprite(x+32, y-32, 'pack' ,'tick-main.png');
                numberTick.setScale(0.65)
                this.add(numberTick);

            }
            
            // Add the text object to this container
            this.add(numberCircle);

            const numberText = this.scene.add.bitmapText(x+1, y-4, 'Montserrat-Bold', number.toString(), 30).setOrigin(0.5);

            // const numberText = this.scene.add.text(x, y, number.toString(), {
            //     fontFamily: 'Montserrat',
            //     fontSize: '30px',
            //     color: '#fff',
            // });
            // numberText.setOrigin(0.5)
            // numberText.setFontStyle('700')

            // Add the text object to this container
            this.add(numberText);
        }
    }


}